module.exports = __webpack_public_path__ + "img/victor-frias.jpg";